import http from "../http-common";
const baseSlug = "/clientMenu";

class menuService {
  getAll() {
    return http.get(`${baseSlug}`);
  }
}

export default new menuService();
